<template>
  <div class="retesting-orders">
    <base-status-orders
      :status="'RETESTING'"
      :title="'复测订单'"
      :show-actions="true">
      <template #actions="{ row }">
        <el-button 
          type="primary" 
          size="mini" 
          @click="handleViewDetail(row)">查看详情</el-button>
        <el-button 
          type="success" 
          size="mini" 
          @click="handleViewResult(row)">查看复测结果</el-button>
      </template>
    </base-status-orders>
    
    <!-- 复测结果对话框 -->
    <el-dialog
      title="复测结果"
      :visible.sync="resultDialogVisible"
      width="600px">
      <div class="retest-info">
        <div class="info-item">
          <span class="label">复测说明：</span>
          <span class="value">{{ currentRetest.description }}</span>
        </div>
        <div class="info-item">
          <span class="label">提交时间：</span>
          <span class="value">{{ currentRetest.createTime }}</span>
        </div>
      </div>
      
      <!-- 复测附件列表 -->
      <div v-if="currentRetest.files && currentRetest.files.length > 0" class="retest-files">
        <h3 class="file-list-title">复测附件</h3>
        <el-table
          :data="currentRetest.files"
          style="width: 100%"
          border>
          <el-table-column
            prop="name"
            label="文件名"
            min-width="300">
          </el-table-column>
          <el-table-column
            prop="size"
            label="大小"
            width="150">
            <template slot-scope="scope">
              {{ formatFileSize(scope.row.size) }}
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="150"
            align="center">
            <template slot-scope="scope">
              <el-button 
                type="text" 
                size="small" 
                @click="handlePreview(scope.row)">预览</el-button>
              <el-button 
                type="text" 
                size="small" 
                @click="handleDownload(scope.row)"
                style="margin-left: 10px;">下载</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import BaseStatusOrders from './BaseStatusOrders.vue'
import adminApi from '@/api/adminApi'

export default {
  name: 'RetestingOrders',
  components: {
    BaseStatusOrders
  },
  data() {
    return {
      resultDialogVisible: false,
      currentRetest: {
        description: '',
        createTime: '',
        files: []
      }
    }
  },
  methods: {
    handleViewDetail(row) {
      this.$router.push(`/admin/orders/detail/${row.id}`)
    },
    handleViewResult(row) {
      // 获取复测结果信息
      this.currentRetest = {
        description: row.retestRemark || '',
        createTime: row.retestCreateTime || '',
        files: row.orderRetestResultFileList || []
      }
      this.resultDialogVisible = true
    },
    handlePreview(file) {
      // 调用统一的预览方法
      adminApi.previewFile(file, this.$message)
        .catch(error => {
          console.error('文件预览失败:', error);
        });
    },
    handleDownload(file) {
      // 调用统一的下载方法
      adminApi.downloadFileUnified(file, this.$message)
        .catch(error => {
          console.error('文件下载失败:', error);
        });
    },
    formatFileSize(size) {
      if (!size) return '0 B'
      const units = ['B', 'KB', 'MB', 'GB']
      let index = 0
      while (size >= 1024 && index < units.length - 1) {
        size /= 1024
        index++
      }
      return size.toFixed(2) + ' ' + units[index]
    }
  }
}
</script>

<style scoped>
.retesting-orders {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
}

.retest-info {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f0f9eb;
  border-radius: 4px;
  color: #67c23a;
}

.info-item {
  margin-bottom: 10px;
}

.info-item .label {
  font-weight: bold;
  margin-right: 10px;
}

.retest-files {
  margin-top: 20px;
}

.file-list-title {
  margin: 0 0 20px 0;
  font-size: 16px;
  color: #303133;
  position: relative;
  padding-left: 12px;
}

.file-list-title:before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 16px;
  background-color: #409eff;
  border-radius: 2px;
}
</style> 